import styled from "styled-components";
import { Link as RouterLink, RouterProps } from "react-router-dom";
import { fontSize } from "styled-system";

export const Link = styled<any>(RouterLink)`
  ${fontSize}
  color: #000;
  text-decoration: none;
`;
